module.exports = __webpack_public_path__ + "static/opensans-regular-webfont-237aa5beb31bb3f930e7f178dd1eaf3b.woff";